import TextField from "@mui/material/TextField";
import { type Control, Controller, type FieldPath } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import { type TRules } from "@/shared/types/form.types";
import { TextInputStyled } from "../TextInput.style";
import { inputStyles, type InputVariant } from "../inputStyles";
interface IMoneyInput<FormNames extends Record<string, any>> {
  control: Control<FormNames>;
  name: FieldPath<FormNames>;
  rules?: TRules<FormNames>;
  label?: string;
  placeholder?: string | number;
  disabled?: boolean;
  inputProps?: any;
  onCustomChange?: any;
  returnValueAsString?: boolean;
  onClick?: any;
  variant?: InputVariant;
}
function MoneyInput<FormNames extends Record<string, any>>({
  control,
  name,
  disabled,
  label,
  placeholder,
  rules,
  inputProps,
  onCustomChange,
  returnValueAsString = false,
  onClick,
  variant = "default",
}: IMoneyInput<FormNames>) {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field, fieldState }) => (
        <TextInputStyled>
          {label && (
            <label htmlFor="">
              {label}
              <span>
                {label && rules?.required ? (
                  <span className="text-red-500 mt-1">*</span>
                ) : null}
              </span>
            </label>
          )}
          <NumericFormat
            // {...field}
            // onChange={(e) => e.target.value}
            value={field.value ?? ""}
            size="small"
            onBlur={field.onBlur}
            placeholder={String(placeholder)}
            disabled={disabled}
            inputProps={inputProps}
            InputProps={{
              ref: field.ref,
            }}
            sx={inputStyles[variant]}
            name={field.name}
            allowLeadingZeros={true}
            thousandSeparator=" "
            allowNegative={false}
            customInput={TextField}
            variant="outlined"
            onClick={onClick}
            onValueChange={(val) => {
              if (returnValueAsString) {
                field.onChange(val.value ?? "");
                onCustomChange?.(val.value);
              } else {
                field.onChange(val.floatValue ?? "");
                onCustomChange?.(val.floatValue);
              }
            }}
          />
          {fieldState.error && (
            <h6 className="text-error">{t(fieldState.error.message!)}</h6>
          )}
        </TextInputStyled>
      )}
    />
  );
}

export default MoneyInput;
